import styled from 'styled-components';
import { GeneralColors, Radius, Spacing } from '../../../../theme';

export interface ILineRoundedWrapper {
  width?: string;
  height?: string;
  background?: GeneralColors;
  padding?: Spacing;
  radius?: Radius;
  cursor?: string;
}

const LineRoundedWrapper = styled.div<ILineRoundedWrapper>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: ${(p) => (p.width ? p.width : '20px')};
  min-width: ${(p) => (p.width ? p.width : '20px')};
  height: ${(p) => (p.height ? p.height : '20px')};
  min-height: ${(p) => (p.height ? p.height : '20px')};
  background: ${(p) => (p.background ? p.theme.colors.general[p.background] : 'transparent')};
  padding: ${(p) => (p.padding ? p.theme.spacing[p.padding] : 'none')};
  border-radius: ${(p) => (p.radius ? p.theme.radius[p.radius] : '0px')};
  cursor: ${({ cursor }) => (cursor ? cursor : 'normal')};
  &:hover {
    drop-shadow: ${(p) => p.theme.shadows.pya};
  }
`;

export default LineRoundedWrapper;
